/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { Image, Link } from '@fluentui/react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withConversionTagData, useInitConversionTagData } from '@bingads-webui-campaign-react/conversion-data';

import { getDoneViewStyles } from '../styles/done-view-styles';
import extensionIconImage from '../../media/extPic.png';
import { chromeExtURL, edgeExtURL } from '../utils/uet-tag-helper-install-urls';

function DoneViewUnstyled(props) {
  const {
    classes,
    tagContext,
  } = props;

  const i18n = useContext(I18nContext);
  useInitConversionTagData(tagContext);

  const { data: tag } = tagContext;
  const isTestGoalSupported = useMemo(() => {
    const tagType = tag && tag.type;
    return tagType === 'UET';
  }, [tag]);

  return (
    <div className={classNames('done-view', classes.doneView)}>
      {isTestGoalSupported && (
        <div className="done-with-browser-extension">
          <p>{i18n.getString(_TL_('Next step to test your conversion goal:'))}</p>

          <p>
            <ReactTemplate
              model={{
                b: text => <strong>{text}</strong>,
                edge: text => <Link href={edgeExtURL} aria-label={text} target="_blank" rel="noopener noreferrer">{text}</Link>,
                chrome: text => <Link href={chromeExtURL} aria-label={text} target="_blank" rel="noopener noreferrer">{text}</Link>,
              }}
              template={i18n.getString(_TL_('{{b}}It can take up to 2 days for us to verify your tags.{{/b}} In the meantime, you can check your UET tag status and test whether your conversion goals are set up correctly using the UET Tag Helper. You can install this browser extension on {{edge}}Microsoft Edge{{/edge}} or {{chrome}}Google Chrome{{/chrome}}.'))}
            />
            <LearnMoreLink
              topic="app54548"
              linkText={i18n.getString(_TL_('Learn more'))}
            />
          </p>

          <Image
            className="browser-extension-icon"
            src={extensionIconImage}
            alt={i18n.getString(_TL_('Extension icon'))}
          />

        </div>
      )}

      {!isTestGoalSupported && (
        <div className="done-without-browser-extension">
          <p>
            <ReactTemplate
              model={{
                b: text => <strong>{text}</strong>,
              }}
              template={i18n.getString(_TL_('{{b}}It can take up to 2 days for us to verify your tags.{{/b}} You can review the installation instructions any time in "Manage Goals" page.'))}
            />
          </p>
        </div>
      )}
    </div>
  );
}

DoneViewUnstyled.propTypes = {
  classes: PropTypes.shape({ doneView: PropTypes.string }).isRequired,
  tagContext: PropTypes.shape({
    data: PropTypes.shape({ type: PropTypes.string }),
  }).isRequired,
};

export const DoneView = withDefaultStyles(withConversionTagData(DoneViewUnstyled), getDoneViewStyles);
